import { show, saveSecret, deleteSecret, checkStatus } from 'webtonative/Biometric';

declare global {
  interface Window {
    WTN?: {
      Biometric?: {
        saveSecret: (options: { secret: string, callback: (data: any) => void }) => void
        show: (options: { prompt: string, callback: (data: any) => void }) => void
        deleteSecret: (options: { callback: (data: any) => void }) => void
        checkStatus?: (options: { callback: (data: any) => void }) => void
      }
    }
  }
}

export const isWebToNativeAvailable = () => {
  return !!(window.WTN?.Biometric || typeof show === 'function');
}

export const isMobileDevice = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

export const shouldUseBiometric = () => {
  return isMobileDevice() && isWebToNativeAvailable();
}

export const saveBiometricToken = (token: string) => {
  if (typeof saveSecret === 'function') {
    saveSecret({
      secret: token,
      callback: function(data: any) {
        console.log('Token saved to biometrics:', data);
      }
    })
  } else if (window.WTN?.Biometric?.saveSecret) {
    window.WTN.Biometric.saveSecret({
      secret: token,
      callback: function(data: any) {
        console.log('Token saved to biometrics (global):', data);
      }
    })
  }
}

export const updateBiometricToken = (newToken: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if (typeof saveSecret === 'function') {
      saveSecret({
        secret: newToken,
        callback: function(data: any) {
          if (data?.isSuccess) {
            resolve(true)
          } else {
            resolve(false)
          }
        }
      })
    } else if (window.WTN?.Biometric?.saveSecret) {
      window.WTN.Biometric.saveSecret({
        secret: newToken,
        callback: function(data: any) {
          if (data?.isSuccess) {
            resolve(true)
          } else {
            resolve(false)
          }
        }
      })
    } else {
      resolve(false)
    }
  })
}

export const showBiometricPrompt = (onSuccess: (token: string) => void, onError?: (error: any) => void) => {
  if (typeof show === 'function') {
    show({
      prompt: 'Authenticate to continue!',
      callback: function(data: any) {
        if (data.isSuccess && data.secret) {
          onSuccess(data.secret);
        } else {
          onError?.(data);
        }
      }
    })
  } else if (window.WTN?.Biometric?.show) {
    window.WTN.Biometric.show({
      prompt: 'Authenticate to continue!',
      callback: function(data: any) {
        if (data.isSuccess && data.secret) {
          onSuccess(data.secret);
        } else {
          onError?.(data);
        }
      }
    })
  }
}

export const deleteBiometricToken = () => {
  if (typeof deleteSecret === 'function') {
    deleteSecret({
      callback: function(data: any) {
        console.log('Biometric token removed:', data);
      }
    })
  } else if (window.WTN?.Biometric?.deleteSecret) {
    window.WTN.Biometric.deleteSecret({
      callback: function(data: any) {
        console.log('Biometric token removed (global):', data);
      }
    })
  }
}

export const checkBiometricStatus = (onStatus: (data: any) => void) => {
  if (typeof checkStatus === 'function') {
    checkStatus({
      callback: onStatus
    })
  } else if (window.WTN?.Biometric?.checkStatus) {
    window.WTN.Biometric.checkStatus({
      callback: onStatus
    })
  }
}
